import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { ModalTitle, Title, TypologiesTable } from './styled';

const TypologiesModal = ({
  apiActions,
  alertId,
  onToggle,
  typologies,
  isLoading = false
}) => {
  const { getAMLSTMCommonTransactionTriggeredTypologies } = apiActions;

  useEffect(() => {
    if (alertId) {
      getAMLSTMCommonTransactionTriggeredTypologies({ alertId });
    }
  }, [alertId]);

  return (
    <Modal size="md" isOpen toggle={onToggle}>
      <ModalHeader toggle={onToggle}>
        <ModalTitle>Typologies</ModalTitle>
      </ModalHeader>
      <ModalBody>
        <Title>Typology Name</Title>
        <TypologiesTable
          dataSource={typologies || []}
          columns={[
            {
              key: 'name',
              dataIndex: 'name'
            }
          ]}
          showHeader={false}
          pagination={false}
          loading={isLoading}
        />
      </ModalBody>
    </Modal>
  );
};

TypologiesModal.propTypes = {
  apiActions: PropTypes.object.isRequired,
  alertId: PropTypes.string.isRequired,
  onToggle: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  typologies: PropTypes.array
};

export default TypologiesModal;
